export const BUILD_VERSION = '1789932463';
